import React from 'react';
import { Button } from './Button';
interface EmptyStateProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  className?: string;
}
export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  actionLabel,
  onAction,
  className = ''
}) => {
  return <div className={`flex flex-col items-center justify-center py-12 px-4 text-center ${className}`} data-id="element-196">
      <div className="w-16 h-16 mb-4 rounded-full bg-surface-secondary flex items-center justify-center text-text-tertiary" data-id="element-197">
        {icon}
      </div>
      <h3 className="text-lg font-semibold text-text-primary mb-2" data-id="element-198">{title}</h3>
      <p className="text-sm text-text-secondary max-w-sm mb-6" data-id="element-199">{description}</p>
      {actionLabel && onAction && <Button onClick={onAction} variant="primary" data-id="element-200">
          {actionLabel}
        </Button>}
    </div>;
};